import { get } from 'lodash';
import { getPaymentsWithAccounts } from '../accounts/selectors';
import { getPaymentsList } from './getPaymentsList';

export const hasExternalPayments = (state) =>
	getPaymentsWithAccounts(state, getPaymentsList(state)).some(
		(payment) => get(payment, 'toAccountDetails.type', '') === 'payee'
	);
